export default __webpack_public_path__ + "static/media/free.2832e2ad.png";